define([
	"dojo/_base/declare",
	"./Number"
], function(declare,NumberRen) {

	return declare(NumberRen, {
		_getFormat: function(/*Context*/ctx, /*Heading*/h) {
			// summary: use configuration setting for format
			return ctx.getNode().SCFormatToleranceDelta;
		}
	});
});